import { render, staticRenderFns } from "./InsCmsCat2.vue?vue&type=template&id=4637aa25&scoped=true&"
import script from "./InsCmsCat2.vue?vue&type=script&lang=ts&"
export * from "./InsCmsCat2.vue?vue&type=script&lang=ts&"
import style0 from "./InsCmsCat2.vue?vue&type=style&index=0&id=4637aa25&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4637aa25",
  null
  
)

export default component.exports